export const hasHTMLTags = (input: string) =>
  !!/<(\/?)(\w+)([^>]*?)>/g.test(input);
